var _a;
import debounce from 'lodash/debounce';
import { useEffect, useState } from 'react';
import { DeviceType } from '../types';
/* Note: These breakpoint values need to be manually synced with those in
 *       app/styles/breakpoints.module.scss
 */
export var viewportMinWidths = (_a = {},
    _a[DeviceType.Mobile] = 0,
    _a[DeviceType.Tablet] = 481,
    _a[DeviceType.Desktop] = 821,
    _a);
var DEBOUNCE_RATE = 400;
export var useViewportWidth = function (initialDeviceType) {
    // if the default value of DeviceType.Mobile is changed
    //  ensure the default DeviceType is also updated in the getDeviceType function
    // /packages/next/src/getters.ts
    var _a = useState(viewportMinWidths[initialDeviceType || DeviceType.Mobile]), viewportWidth = _a[0], setViewportWidth = _a[1];
    useEffect(function () {
        setViewportWidth(window.innerWidth);
        var updateScreenSize = debounce(function () {
            setViewportWidth(window.innerWidth);
        }, DEBOUNCE_RATE);
        window.addEventListener('resize', updateScreenSize);
        return function () {
            window.removeEventListener('resize', updateScreenSize);
        };
    }, []);
    return {
        viewportWidth: viewportWidth,
        isOrAbove: function (deviceType) {
            if (typeof viewportWidth === 'undefined') {
                return false;
            }
            var viewportMinWidth = viewportMinWidths[deviceType];
            return viewportWidth >= viewportMinWidth;
        },
    };
};
